export const handleReadySchedulesForPatching = (schedules: any) => {
  const returnSchedules = schedules;

  returnSchedules.forEach((schedule: any, index: number) => {
    if (schedule.start_time !== null) {
      if (schedule.start_time === ":00" || schedule.start_time === " - :00") {
        returnSchedules[index].start_time = null;
      }
    }
    if (schedule.end_time !== null) {
      if (schedule.end_time === ":00" || schedule.end_time === " - :00") {
        returnSchedules[index].end_time = null;
      }
    }
  });

  //remove any schedule object that has a null start_time and end_time and false value for "always_on"
  for (let i = 0; i < returnSchedules.length; i++) {
    if (
      returnSchedules[i].start_time === null &&
      returnSchedules[i].end_time === null &&
      returnSchedules[i].always_on === false
    ) {
      returnSchedules.splice(i, 1);
    }
  }
  return returnSchedules;
};
